import React, { useState, useEffect } from 'react';
import { Typography, Grid, Paper, Button, Divider, FormControl, InputLabel, Select, MenuItem, Box, Card } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { getApi } from 'views/services/api';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PrintIcon from '@mui/icons-material/Print';
import LocalHotelIcon from '@mui/icons-material/LocalHotel';
import ReceiptIcon from '@mui/icons-material/Receipt';

const RoomInvoice = () => {
  const [invoiceData, setInvoiceData] = useState({});
  const [itemsData, setitemsData] = useState([]);
  const [currencyCode, setCurrencyCode] = useState('');
  const [hotelData, setHotelData] = useState('');
  const [printSize, setPrintSize] = useState('A5');
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const params = useParams();
  const _id = params.id;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        const response = await getApi(`api/invoice/viewspecificinvoice/${_id}`);
        if (hotel?.hotelId) {
          let hotelDataResponse = await getApi(`api/hotel/view/${hotel?.hotelId}`);
          setHotelData(hotelDataResponse?.data);
        }
        setInvoiceData(response?.data?.InvoiceData);

        if (hotel?.currencyCode === 'INR') {
          setCurrencyCode('\u20B9');
        } else {
          setCurrencyCode(hotel?.currencyCode);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchInvoiceData();
  }, [_id]);

  const handlePrint = () => {
    window.print();
  };

  const handlePrintSizeChange = (event) => {
    setPrintSize(event.target.value);
  };

  const currentDate = new Date(invoiceData?.createdDate).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  const formatTime = (timeString) => {

    if (!timeString) return '';

    const [datePart, timePart, meridian] = timeString.split(" ");
    return datePart + " at " + timePart + " " + meridian;
    const hours = parseInt(timeParts[0], 10);
    const minutes = timeParts[1];

    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    console.log({})
    // Get today's date
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();

    return `${timeParts}/${month}/${year} at ${formattedHours}:${minutes}`;
  };


  const fetchitemsData = async () => {
    try {
      const response = await getApi(`api/reservation/getfooditems/${invoiceData.reservationId}`);
      setitemsData(response?.data?.foodItemsData[0]?.foodItems);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (invoiceData.type === 'food') {
      fetchitemsData();
    }
  }, [invoiceData.type]);

  return (
<Box
  sx={{
    padding: '20px',
    backgroundColor: '#f5f5f5',
    minHeight: 'auto'   // ← safest for print
  }}
>

      {/* Header with controls - hidden when printing */}
      <Box className="no-print" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          sx={{
            color: '#5a4b81',
            borderColor: '#5a4b81',
            '&:hover': {
              backgroundColor: '#f0edf5',
              borderColor: '#5a4b81'
            }
          }}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <FormControl sx={{ minWidth: 120 }} size="small">
            <InputLabel id="print-size-label">Paper Size</InputLabel>
            <Select
              labelId="print-size-label"
              value={printSize}
              label="Paper Size"
              onChange={handlePrintSizeChange}
            >
              <MenuItem value="A4">A4</MenuItem>
              <MenuItem value="A5">A5</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant="contained"
            onClick={handlePrint}
            startIcon={<PrintIcon />}
            sx={{
              backgroundColor: '#5a4b81',
              '&:hover': {
                backgroundColor: '#42385e'
              }
            }}
          >
            Print Invoice
          </Button>
        </Box>
      </Box>

      {/* Invoice Content - visible when printing */}
      <Box className="invoice-container" sx={{
        backgroundColor: 'white',
        padding: '30px',
        maxWidth: printSize === 'A4' ? '800px' : '600px',
        margin: '0 auto',
        boxShadow: '0px 5px 15px rgba(0,0,0,0.1)',
        border: '1px solid #e0e0e0',
        borderRadius: '8px'
      }}>
        {/* Invoice Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,gap:1 }}>
             <img src={`https://neorooms.in/api/${hotel?.hotelImage}`}  style={{ width:"40px",height:"40px" }} />
              <Typography variant="h4" sx={{ color: '#5a4b81', fontWeight: 'bold' }}>
                {hotel?.name ? hotel?.name : hotelData?.name}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#666' }}>
              {hotelData?.address ? hotelData?.address : hotel?.address}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666' }}>
              Tel: {hotel?.contact ? hotel?.contact : hotelData?.contact}
            </Typography>
            
              <Typography variant="body2" sx={{ color: '#666' }}>
                GST: {hotel?.gstNumber}
              </Typography>
            
          </Box>

          <Box sx={{ textAlign: 'right' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', mb: 1 }}>
              <ReceiptIcon sx={{ color: '#5a4b81', mr: 1 }} />
              <Typography variant="h5" sx={{ color: '#5a4b81', fontWeight: 'bold' }}>
                INVOICE
              </Typography>
            </Box>
            <Typography variant="body2">
              <strong>Invoice #:</strong> {invoiceData?.invoiceNumber}
            </Typography>
            <Typography variant="body2">
              <strong>Date:</strong> {currentDate}
            </Typography>
            <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>
              <strong>Type:</strong> {invoiceData?.type}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor: '#5a4b81', borderWidth: '1px', mb: 2 }} />

        <Grid container spacing={3}>
          {/* Customer Details */}
          <Grid item  xs={6}>
            <Typography variant="h6" sx={{ color: '#5a4b81', fontWeight: 'bold', mb: 1 }}>
              BILL TO
            </Typography>
            <Card variant="outlined" sx={{ padding: '16px', backgroundColor: '#f9f9f9' }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {invoiceData?.name}
              </Typography>
              <Typography variant="body2" sx={{ mt: 0.5 }} fontSize="13px">
                {invoiceData?.address}
              </Typography>
              <Typography variant="body2" sx={{ mt: 0.5 }} fontSize="13px">
                Phone: {invoiceData?.customerPhoneNumber}
              </Typography> 
  
                 {invoiceData?.haveGST && (<Typography variant="body2" sx={{ mt: 0.5 }} fontSize="13px">
                 GST:  {invoiceData?.gstNumber}
              </Typography> )}
            </Card>
          </Grid>

          {/* Stay Details */}
          <Grid item xs={6}>
            <Typography variant="h6" sx={{ color: '#5a4b81', fontWeight: 'bold', mb: 1 }}>
              STAY DETAILS
            </Typography>
            <Card variant="outlined" sx={{ padding: '16px', backgroundColor: '#f9f9f9' }}>
              {invoiceData?.FinalCheckInTime && (
                <Typography variant="body2" fontSize="13px">
                  <strong>Check-In:</strong> {formatTime(invoiceData?.FinalCheckInTime)}
                </Typography>
              )}
              {invoiceData?.FinalCheckOutTime && (
                <Typography variant="body2" sx={{ mt: 0.5 }} fontSize="13px">
                  <strong>Check-Out:</strong> {formatTime(invoiceData?.FinalCheckOutTime)}
                </Typography>
              )}
              {invoiceData.advancePaymentMethod && (
                <Typography variant="body2" sx={{ mt: 0.5 }} fontSize="13px">
                  <strong>Advance Payment:</strong> {invoiceData?.advancePaymentMethod}
                </Typography>
              )}
              {invoiceData.paymentMethod && (
                <Typography variant="body2" sx={{ mt: 0.5 }} fontSize="13px">
                  <strong>Payment Method:</strong> {invoiceData?.paymentOption}
                </Typography>
              )}
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
            <Typography variant="h6" sx={{ color: '#5a4b81', fontWeight: 'bold', mb: 2 }}>
              INVOICE DETAILS
            </Typography>

            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#f0edf5' }}>
                    <TableCell sx={{ fontWeight: 'bold', padding: '12px' }}>Description</TableCell>
                    {invoiceData.type === 'food' && (
                      <>
                        <TableCell sx={{ fontWeight: 'bold', padding: '12px' }}>Price</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', padding: '12px' }}>Quantity</TableCell>
                      </>
                    )}
                    <TableCell align="right" sx={{ fontWeight: 'bold', padding: '12px' }}>Amount</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {invoiceData?.roomRent && (
                    <TableRow>
                      <TableCell sx={{ padding: '10px', fontSize: "13px" }}><b>Room Charges</b></TableCell>
                      {invoiceData.type === 'food' && <TableCell colSpan={2}></TableCell>}
                      <TableCell align="right" sx={{ padding: '10px', fontSize: "13px" }}>
                        <b>{currencyCode} {invoiceData?.pendingAmount + invoiceData?.advanceAmount - invoiceData?.extraBedsCharge}</b>
                      </TableCell>
                    </TableRow>
                  )}

                  {invoiceData.type !== 'food' && invoiceData.extraBedsCharge > 0 && (
                    <TableRow>
                      <TableCell sx={{ padding: '10px', fontSize: "13px" }}><b>Extra Bed Charges</b></TableCell>
                      <TableCell align="right" sx={{ padding: '10px', fontSize: "13px" }}>
                        <b>{currencyCode} {invoiceData.extraBedsCharge || 0}</b>
                      </TableCell>
                    </TableRow>
                  )}

                  {invoiceData.type !== 'food' && invoiceData.extraStayCharge > 0 && (
                    <TableRow>
                      <TableCell sx={{ padding: '10px', fontSize: "13px" }}><b>Extra Stay Charge</b></TableCell>
                      <TableCell align="right" sx={{ padding: '10px', fontSize: "13px" }}>
                        <b>{currencyCode} {invoiceData.extraStayCharge || 0}</b>
                      </TableCell>
                    </TableRow>
                  )}

                  {invoiceData.type === 'food' &&
                    itemsData?.map((foodItem) => (
                      <TableRow key={foodItem._id}>
                        <TableCell sx={{ padding: '10px', fontSize: "13px" }}><b>{foodItem.name}</b></TableCell>
                        <TableCell sx={{ padding: '10px', fontSize: "13px" }}>{currencyCode} {foodItem.price}</TableCell>
                        <TableCell sx={{ padding: '10px', fontSize: "13px" }}>{foodItem.quantity}</TableCell>
                        <TableCell align="right" sx={{ padding: '10px', fontSize: "13px" }}>
                          <b>{currencyCode} {foodItem.totalAmountFood}</b>
                        </TableCell>
                      </TableRow>
                    ))}

                  {invoiceData.foodAmount > 0 && (
                    <TableRow>
                      <TableCell sx={{ padding: '10px', fontSize: "13px" }}><b>Food Amount</b></TableCell>
                      {invoiceData.type === 'food' && <TableCell colSpan={2}></TableCell>}
                      <TableCell align="right" sx={{ padding: '10px', fontSize: "13px" }}>
                        <b>{currencyCode} {invoiceData.foodAmount || 0}</b>
                      </TableCell>
                    </TableRow>
                  )}

                  {invoiceData.type !== 'food' && invoiceData.advanceAmount > 0 && (
                    <TableRow>
                      <TableCell sx={{ padding: '10px', fontSize: "13px" }}><b>Advance Payment</b></TableCell>
                      {invoiceData.type === 'food' && <TableCell colSpan={2}></TableCell>}
                      <TableCell align="right" sx={{ padding: '10px', fontSize: "13px" }}>
                        <b>{currencyCode} {invoiceData.advanceAmount || 0}</b>
                      </TableCell>
                    </TableRow>
                  )}

                  {invoiceData.discount > 0 && (
                    <TableRow>
                      <TableCell sx={{ padding: '10px', fontSize: "13px" }}><b>Discount</b></TableCell>
                      {invoiceData.type === 'food' && <TableCell colSpan={2}></TableCell>}
                      <TableCell align="right" sx={{ padding: '10px', fontSize: "13px", color: 'red' }}>
                        <b>- {currencyCode} {invoiceData.discount ? invoiceData.discount : 0}</b>
                      </TableCell>
                    </TableRow>
                  )}

                  {invoiceData.haveGST && invoiceData.gstAmount > 0 && (
                    <TableRow>
                      <TableCell sx={{ padding: '10px', fontSize: "13px" }}><b>Tax ({invoiceData.gstPercentage || 12}%)</b></TableCell>
                      {invoiceData.type === 'food' && <TableCell colSpan={2}></TableCell>}
                      <TableCell align="right" sx={{ padding: '10px', fontSize: "13px" }}>
                        <b>{currencyCode} {invoiceData.gstAmount}</b>
                      </TableCell>
                    </TableRow>
                  )}

                  {/* Grand Total */}
                  <TableRow sx={{ borderTop: '2px solid #ddd' }}>
                    <TableCell sx={{ padding: '10px', fontSize: "13px" }}><b>Grand Total</b></TableCell>
                    {invoiceData.type === 'food' && <TableCell colSpan={2}></TableCell>}
                    <TableCell align="right" sx={{ padding: '10px', fontSize: "13px" }}>
                      <b>{currencyCode} {invoiceData.totalAmount + (invoiceData.extraStayCharge ?? 0)}</b>
                    </TableCell>
                  </TableRow>

                  {invoiceData.type !== 'food' && invoiceData.advanceAmount > 0 && (
                    <TableRow>
                      <TableCell sx={{ padding: '10px', fontSize: "13px" }}><b>Amount Paid</b></TableCell>
                      {invoiceData.type === 'food' && <TableCell colSpan={2}></TableCell>}
                      <TableCell align="right" sx={{ padding: '10px', fontSize: "13px" }}>
                        <b>{currencyCode} {invoiceData.advanceAmount || 0}</b>
                      </TableCell>
                    </TableRow>
                  )}

                  {invoiceData?.pendingAmount > 0 && invoiceData.type !== 'food' && (
                    <TableRow sx={{ backgroundColor: '#fff5f5' }}>
                      <TableCell sx={{ padding: '10px', fontSize: "13px" }}><b>Balance Due</b></TableCell>
                      <TableCell align="right" sx={{ padding: '10px', fontSize: "13px" }}>
                        <b>{currencyCode} {invoiceData?.pendingAmount + (invoiceData.extraStayCharge ?? 0) - (invoiceData.discount ? invoiceData.discount : 0)}</b>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ mt: 1, p: 1, backgroundColor: '#f9f9f9', borderRadius: '4px' }}>
              <Typography variant="body2" sx={{ fontStyle: 'italic' }} fontSize={12}>
                Thank you for your stay. We look forward to serving you again!
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', mt: 4 }}>
            <Box sx={{ textAlign: 'center', flex: 1 }}>
              <Typography variant="body2" sx={{ borderTop: '1px solid #000', display: 'inline-block', paddingTop: '10px', minWidth: '150px' }}>
                Guest Signature
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'center', flex: 1 }}>
              <Typography variant="body2" sx={{ borderTop: '1px solid #000', display: 'inline-block', paddingTop: '10px', minWidth: '150px' }}>
                Authorized Signature
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Print Styles */}
<style>
{`
@media print {
  @page {
    size: ${printSize};
    margin: ${printSize === 'A5' ? '5mm' : '10mm'};
  }

  body {
    margin: 0;
  }

  body * {
    visibility: hidden;
  }

  .invoice-container,
  .invoice-container * {
    visibility: visible;
    font-size: ${printSize === 'A5' ? '10px' : '12px'} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .no-print {
    display: none !important;
  }

  .invoice-container {
    position: static !important;
    width: 100%;
    margin: 0 auto !important;
    padding: 6mm !important;
    box-shadow: none !important;
    border: none !important;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }

  tr {
    page-break-inside: avoid;
  }

  th, td {
    padding: 4px !important;
  }

  img {
    max-width: 100%;
    height: auto;
  }
}

`}
</style>


    </Box>
  );
};

export default RoomInvoice;